import React from "react";
import { Button, Col, Row, Card, Form } from "react-bootstrap";
import HeaderMobile from "../layouts/HeaderMobile";

export default function Pricing() {
  const plans = [
    {
      id: "free",
      name: "무료",
      price: "0",
      description: "기본 기능을 무료로 체험해보세요",
      features: [
        { name: "핵심 기능 사용", available: true },
        { name: "광고 포함", available: true },
        { name: "API 제공", available: false },
        { name: "우선 지원", available: false },
      ],
      buttonText: "무료 시작",
      buttonVariant: "outline-light"
    },
    {
      id: "premium",
      name: "프리미엄",
      price: "19,900",
      description: "광고 없는 쾌적한 환경",
      isPopular: true,
      features: [
        { name: "모든 기본 기능", available: true },
        { name: "광고 완전 제거", available: true },
        { name: "빠른 로딩 속도", available: true },
        { name: "우선 업데이트", available: true },
      ],
      buttonText: "구독 시작",
      buttonVariant: "primary"
    },
    {
      id: "api",
      name: "엔터프라이즈",
      price: "별도 문의",
      description: "강력한 API로 서비스를 확장하세요",
      notice: "별도 문의",
      tag: "API",
      features: [
        { name: "모든 프리미엄 기능", available: true },
        { name: "광고 완전 제거", available: true },
        { name: "RESTful API 제공", available: true },
        { name: "API 문서 및 샘플 코드", available: true },
        { name: "전담 기술 지원", available: true },
        { name: "SLA 99.9% 보장", available: true },
      ],
      buttonText: "API 문서 보기",
      buttonVariant: "outline-light",
      withForm: true,
      featureBox: true
    }
  ];

  const coreValues = [
    {
      icon: "ri-eye-line",
      title: "광고 제거",
      description: "몰입을 깨는 요소 없이 정보에만 집중하세요.",
      tag: "로딩 속도 개선",
      tone: "blue",
    },
    {
      icon: "ri-code-s-slash-line",
      title: "RESTful API 제공",
      description: "엔터프라이즈 플랜으로 데이터 연동을 확장하세요.",
      tag: "무제한 호출 옵션",
      tone: "purple",
    },
  ];

  const includedFeatures = [
    {
      icon: "ri-flashlight-line",
      title: "빠른 성능",
      description: "광고 제거로 페이지 응답이 더 빨라집니다.",
    },
    {
      icon: "ri-shield-check-line",
      title: "안전한 연동",
      description: "안정적인 인증으로 보안을 강화합니다.",
    },
    {
      icon: "ri-bar-chart-grouped-line",
      title: "실시간 분석",
      description: "사용량과 트래픽을 빠르게 확인하세요.",
    },
    {
      icon: "ri-rocket-line",
      title: "빠른 도입",
      description: "문서와 샘플로 빠르게 적용할 수 있습니다.",
    },
    {
      icon: "ri-notification-3-line",
      title: "알림 서비스",
      description: "주요 이벤트를 바로 알려드립니다.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "전담 지원",
      description: "엔터프라이즈 고객 전용 지원 제공.",
    },
  ];

  const compareRows = [
    { label: "광고 제거", values: [false, true, true] },
    { label: "API 제공", values: [false, false, true] },
    { label: "API 호출 제한", values: ["-", "-", "무제한"] },
    { label: "기술 지원", values: ["커뮤니티", "이메일", "전담 지원"] },
    { label: "SLA 보장", values: [false, false, "99.9%"] },
  ];

  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main-pricing pricing-gw p-4 p-lg-5">
        <div className="pricing-hero text-center">
          <div className="pricing-pill">
            <i className="ri-information-line"></i>
            <span>체험 기간 동안에는 모든 기능을 무료로 이용할 수 있습니다. (예시: 2026년 00월 ~ 2026년 00월)</span>
          </div>
          <h1 className="pricing-title">투자 데이터를 효율적으로 이용하세요.</h1>
          <p className="pricing-text">
            <span className="d-block">기업에는 API 형태로 분석 데이터를 제공하고,</span>
            <span className="d-block">개인 사용자에게는 광고 없는 이용 환경을 제공합니다.</span>
          </p>
          <div className="d-flex justify-content-center gap-2 mt-4 flex-wrap">
            <Button variant="primary" className="fw-medium px-4">무료로 시작</Button>
            <Button variant="outline-light" className="fw-medium px-4" href="mailto:junsung.lim@guruwhisper.com">이메일 전송</Button>
          </div>
        </div>

        <Row className="g-4 justify-content-center gw-plan-row">
          {plans.map((plan) => (
            <Col xl="4" md="6" key={plan.id}>
              <Card className={`gw-plan-card h-100 ${plan.isPopular ? "gw-plan-card--featured" : ""}`}>
                <Card.Body className="p-4 d-flex flex-column">
                  {plan.isPopular && <div className="gw-plan-badge">Popular</div>}
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <h5 className="fw-bold mb-0 plan-eyebrow">{plan.name}</h5>
                      {plan.tag && <span className="gw-plan-tag">{plan.tag}</span>}
                    </div>
                    <div className="d-flex align-items-baseline mb-2">
                      {plan.notice ? (
                        <div className="fw-bold mb-0 display-6">{plan.notice}</div>
                      ) : (
                        <>
                          <h2 className="fw-bold mb-0 display-6">₩{plan.price}</h2>
                          <span className="plan-period ms-1">/월</span>
                        </>
                      )}
                    </div>
                    <p className="plan-desc mb-0">{plan.description}</p>
                  </div>

                  {!plan.withForm && (
                    <Button variant={plan.buttonVariant} className="w-100 mb-4 fw-medium py-2">
                      {plan.buttonText}
                    </Button>
                  )}

                  {plan.featureBox ? (
                    <div className="plan-feature-box">
                      <ul className="list-unstyled mb-0 fs-sm plan-feature-list">
                        {plan.features.map((feature, idx) => {
                          const muted = feature.available === false;
                          return (
                            <li key={idx} className={`d-flex align-items-start mb-3 ${muted ? "plan-feature--muted" : ""}`}>
                              <i className="ri-check-line me-2"></i>
                              <span>{feature.name}</span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    <ul className="list-unstyled mb-0 fs-sm flex-grow-1 plan-feature-list">
                      {plan.features.map((feature, idx) => {
                        const muted = feature.available === false;
                        return (
                          <li key={idx} className={`d-flex align-items-start mb-3 ${muted ? "plan-feature--muted" : ""}`}>
                            <i className="ri-check-line me-2"></i>
                            <span>{feature.name}</span>
                          </li>
                        );
                      })}
                    </ul>
                  )}

                  {plan.withForm && (
                    <div className="plan-api-panel mt-4">
                      <Button variant="outline-primary" className="w-100 mb-3">API 문서 보기</Button>
                      <div className="small text-muted mb-2">API 연동 문의하기</div>
                      <Form.Control type="email" placeholder="이메일 주소" className="mb-2 plan-input" />
                      <Form.Control as="textarea" rows={3} placeholder="문의 내용 (선택사항)" className="mb-3 plan-input" />
                      <Button variant="primary" className="w-100">API 연동 문의</Button>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="gw-section">
          <div className="text-center mb-4">
            <h2 className="gw-section-title">핵심 가치</h2>
            <p className="gw-section-subtitle">두 가지 핵심 기능으로 경험을 빠르게 업그레이드하세요.</p>
          </div>
          <Row className="g-4">
            {coreValues.map((item) => (
              <Col md={6} key={item.title}>
                <div className={`gw-value-card gw-value-card--${item.tone}`}>
                  <div className="gw-value-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="gw-value-body">
                    <h5>{item.title}</h5>
                    <p>{item.description}</p>
                    <span className="gw-value-tag">{item.tag}</span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="gw-section">
          <div className="text-center mb-4">
            <h2 className="gw-section-title">포함된 모든 기능</h2>
            <p className="gw-section-subtitle">유료 플랜에서 제공되는 추가 혜택을 확인하세요.</p>
          </div>
          <Row className="g-3">
            {includedFeatures.map((item) => (
              <Col md={6} lg={4} key={item.title}>
                <div className="gw-feature-card">
                  <div className="gw-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div>
                    <h6>{item.title}</h6>
                    <p>{item.description}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="gw-section">
          <div className="gw-compare-card">
            <h3 className="text-center mb-4">플랜 비교</h3>
            <div className="table-responsive">
              <table className="table gw-compare-table mb-0">
                <thead>
                  <tr>
                    <th>기능</th>
                    <th>무료</th>
                    <th>프리미엄</th>
                    <th>엔터프라이즈</th>
                  </tr>
                </thead>
                <tbody>
                  {compareRows.map((row) => (
                    <tr key={row.label}>
                      <td>{row.label}</td>
                      {row.values.map((value, idx) => (
                        <td key={idx}>
                          {typeof value === "boolean" ? (
                            <i className={value ? "ri-check-line text-success" : "ri-close-line text-muted"}></i>
                          ) : (
                            <span className="fw-semibold">{value}</span>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="gw-cta">
          <h3 className="mb-2">지금 바로 시작하세요</h3>
          <p className="mb-4">무료 체험 기간 동안 모든 프리미엄 기능을 경험할 수 있습니다.</p>
          <Button variant="primary" className="fw-medium px-4">무료로 시작하기</Button>
        </div>
      </div>
    </React.Fragment>
  );
}
